require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-as-part-of-bics-outreach-to-local-civil-society-organizations.json") })
        }
      }, "path---en-us-update-as-part-of-bics-outreach-to-local-civil-society-organizations");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-as-part-of-bics-outreach-to-local-civil-society-organizations!./.cache/json/en-us-update-as-part-of-bics-outreach-to-local-civil-society-organizations.json
// module id = 615
// module chunks = 231608221292675